<template lang="pug">
  .date-slider
    .date-slider__subtract
      img.arrow-img.to-click(src="../../../static/images/arrow_down.svg", @click="subtract")
    .date-slider__date
      .to-click.noselect(@click="openDatePicker", style="text-align: center;") {{ formatedDate }}

      transition(name="bounce")
        .v-calendar-wrapper(v-if="showDatePicker", v-click-outside="hideDatePicker")
          v-date-picker(v-model="value" is-inline, v-if="viewMode === 'day'",  locale="pt-PT")

          datepicker(
            v-else=""
            v-model="value"
            :inline="true"
            :language="ptBR"
            minimumView="month"
            maximumView="month"
            input-class="input-date-timesheet-header"
            calendar-class="p-datepicker__calendar vc-container vc-relative vc-reset vc-border vc-border-gray-400 vc-rounded-lg vc-text-gray-900 vc-bg-white"
            @selected="hideDatePicker"
          )

    .date-slider__add
      img.arrow-img.to-click(src="../../../static/images/arrow_down.svg", @click="add")

</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  data () {
    return {
      ptBR: ptBR,
      showDatePicker: false
    }
  },
  props: {},
  computed: {
    startDate () { return moment(this.$store.state.whb.startDate) },
    endDate () { return moment(this.$store.state.whb.endDate) },
    viewMode () {
      return this.$store.state.whb.type === 'employee' ? 'month' : 'day'
    },
    value: {
      get () {
        return this.endDate.toDate()
      },
      set (value) {
        if (value !== this.value) {
          if (this.viewMode === 'day') {
            this.hideDatePicker()
          }
          this.setDates(moment(value, 'DD/MM/YYYY'))
          // this.$emit('change', moment(value, 'DD/MM/YYYY'))
        }
      }
    },
    formatedDate () {
      const format = this.viewMode === 'day' ? 'dddd - DD/MM/YYYY' : 'MMMM YYYY'
      return moment(this.value).format(format).toUpperCase()
    }
  },
  methods: {
    openDatePicker () { this.showDatePicker = !this.showDatePicker },
    hideDatePicker () { this.showDatePicker = false },
    subtract () {
      let endDate = null
      if (this.viewMode === 'month') {
        endDate = this.endDate.subtract(1, 'month')
      } else {
        endDate = this.endDate.subtract({ days: 1 })
      }
      this.setDates(endDate)
      // this.$emit('change', endDate)
    },
    add () {
      let endDate = this.endDate

      if (this.viewMode === 'month') {
        endDate = this.endDate.clone().add(1, 'month')
      } else {
        endDate = this.endDate.clone().add({ days: 1 })
      }
      this.setDates(endDate)
      // this.$emit('change', endDate)
    },
    setDates (newDate) {
      const stringDate = newDate.format('YYYY-MM-DD')
      this.$store.commit('whb/startDate', stringDate)
      this.$store.commit('whb/endDate', stringDate)
      this.$emit('load')
    }
  },
  components: { Datepicker }
}
</script>

<style>
.input-date-timesheet-header{
  border: none;
  width: 100%;
  text-align: center;
  background-color: transparent;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  margin-top: 0px !important;
}
.month__year_btn {
  border-bottom-style: solid;
  border-bottom-width: 0px;
  border-left-color: rgb(226, 232, 240);
  border-left-style: solid;
  border-left-width: 0px;
  border-right-color: rgb(226, 232, 240);
  border-right-style: solid;
  border-right-width: 0px;
  border-top-color: rgb(226, 232, 240);
  border-top-style: solid;
  border-top-width: 0px;
  box-sizing: border-box;
  color: rgb(45, 55, 72);
  cursor: pointer;
  display: block;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 600;
  height: 27px;
  line-height: 27px;
  user-select: none;
  white-space: nowrap;
  width: 120.078px;
  -webkit-font-smoothing: antialiased;
}
</style>

<style scoped>
.date-slider {
  width: 100%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.5fr 6fr 0.5fr;
  grid-template-areas:
    "subtract-buttton display add-button";
  align-items: end;
}

.v-calendar-wrapper > * {
  font-family: var(--font) !important;
}

.date-slider__subtract { grid-area: subtract-buttton; }
.date-slider__date {
  grid-area: display;
  font-size: 20px;
}
date-slider__date > div {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}
.date-slider__add { grid-area: add-button; }

.arrow-img {
  height: 15px;
}
.date-slider__subtract .arrow-img {
  transform: rotate(90deg);
}

.date-slider__add .arrow-img {
  transform: rotate(-90deg);
}

.vdp-datepicker {
  position: absolute !important;
}
.v-calendar-wrapper {
  position: absolute !important;
  z-index: 2000 !important;
  margin-top: 10px;
  margin-left: 20px;
  align-self: baseline;
}

.vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next {
  background-color: black;
}

.vdp-datepicker__calendar span.cell.month {
  font-size: 5px;
}
</style>

<style>
/* STYLE OF LEGACY DATEPICKER THAT SUPORTS MONTHS AND YEARS */

.vdp-datepicker__calendar span.cell.month {
  font-size: 17px;
}

.p-datepicker__calendar {
  /*width: 250px !important;*/
  /*height: 250px !important;*/
  /*font-family: rubik-regular, serif !important;*/
  /*font-size: 14px !important;*/
  /*animation: slide-down 0.2s ease-in;*/
}

.p-datepicker__calendar .cell{
  /*height: 29px !important;*/
  /*line-height: 30px !important;*/
}

.p-datepicker__calendar .cell.selected{
  background: var(--color-primary) !important;
  color: white;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover   {
  transition: border 0.2s ease;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover   {
  border: 1px solid var(--color-primary) !important;
}
</style>
